var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, ViewChild, Utils, PropertyConverters, Components, Defaults } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
export var LoaderType;
(function (LoaderType) {
    LoaderType["Spinner"] = "spin";
    LoaderType["Pacem"] = "pacem";
    LoaderType["Custom"] = "custom";
})(LoaderType || (LoaderType = {}));
;
let PacemLoaderElement = class PacemLoaderElement extends Components.PacemElement {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        var id = '_' + Utils.uniqueCode();
        this._svgSpinner.innerHTML = `<defs>
                    <mask id="hole${id}">
                        <rect width="100%" height="100%" fill="white" />
                        <circle cx="36" cy="36" r="12"></circle>
                        <path d="M18,0 L32,16 H40 L54,0 Z" fill="#000"></path>
                        <g transform="rotate(120,36,36)">
                            <path d="M18,0 L32,16 H40 L54,0 Z" fill="#000"></path>
                        </g>
                    </mask>
                </defs>

                <circle class="circle1" cx="36" cy="36" r="34" stroke-width="4" fill="none"></circle>
                <g class="gear">
                    <circle cx="36" cy="36" r="25" mask="url(#hole${id})"></circle>
                </g>
                <circle class="circle2" cx="36" cy="36" r="8" stroke-width="2" fill="none"></circle>

                <g class="bounds">
                    <path d="M8,0 H0 V8 M64,0 H71 V8 M71,63 V71 H64 M8,71 H0 V63" stroke-width="2"></path>
                </g>`;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!Utils.isNull(this._container)) {
            switch (name) {
                case 'active':
                case 'disabled':
                    if (this.active === true && !this.disabled) {
                        Utils.addClass(this._container, 'active');
                    }
                    else {
                        Utils.removeClass(this._container, 'active');
                    }
                    break;
                case 'type':
                    this._svgSpinner.setAttribute('hidden', 'hidden');
                    this._spinner.setAttribute('hidden', 'hidden');
                    switch (val) {
                        case LoaderType.Pacem:
                            this._svgSpinner.removeAttribute('hidden');
                            break;
                        default:
                            this._spinner.removeAttribute('hidden');
                            break;
                    }
                    break;
            }
        }
    }
};
__decorate([
    ViewChild('div.' + PCSS + '-spinner')
], PacemLoaderElement.prototype, "_spinner", void 0);
__decorate([
    ViewChild('div.' + PCSS + '-loader')
], PacemLoaderElement.prototype, "_container", void 0);
__decorate([
    ViewChild('svg')
], PacemLoaderElement.prototype, "_svgSpinner", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemLoaderElement.prototype, "active", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemLoaderElement.prototype, "type", void 0);
PacemLoaderElement = __decorate([
    CustomElement({
        tagName: P + '-loader', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-loader" pacem>
            <div class="${PCSS}-spinner" pacem>
                <div></div>
                <div></div>
            </div>
            <svg class="${PCSS}-spinner" pacem hidden xmlns="http://www.w3.org/2000/svg" 
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 viewBox="-18,-18,108,108" preserveAspectRatio="xMidYMid">
            </svg>
        </div>`
    })
], PacemLoaderElement);
export { PacemLoaderElement };
